'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _adminUserEditForm = require('./admin-user-edit-form.component');

var _adminUserEditForm2 = _interopRequireDefault(_adminUserEditForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.admin.adminUserEditForm', []).component('adminUserEditForm', _adminUserEditForm2.default).value('EventEmitter', function (payload) {
  return { $event: payload };
}).name;


// WEBPACK FOOTER //
// ./components/app/admin/admin-users/admin-user-edit-form/admin-user-edit-form.module.js